// 3 bloki poniżej bannera głównego
// @ts-nocheck

import React from "react";
import { useGetCmsSectionArticles } from "api/endpoints/useGetCmsSectionArticles";
import classnames from "classnames";
import { useSelector } from "store";

import styles from "theme/pages/Home/components/HomeBlocks/HomeBlocks.module.scss";

/** Identyfikatory pól sekcji HOMEPAGE_BLOCKS - jednoznacznie mapują dane z backendu */
const HOMEPAGE_BLOCKS_FIELD_IDS = {
  TITLE: 159,
  IMAGE: 160,
  LINK: 161,
} as const;

/**
 * Mapuje article_fields z backendu na tytuł, link i URL obrazka.
 * Używa section_field_id do jednoznacznej identyfikacji pól (niezależnie od kolejności w tablicy).
 */
function mapHomeBlockFields(articleFields) {
  const getField = (sectionFieldId) =>
    articleFields?.find((f) => f.section_field_id === sectionFieldId);

  const titleField = getField(HOMEPAGE_BLOCKS_FIELD_IDS.TITLE);
  const imageField = getField(HOMEPAGE_BLOCKS_FIELD_IDS.IMAGE);
  const linkField = getField(HOMEPAGE_BLOCKS_FIELD_IDS.LINK);

  const title =
    typeof titleField?.value === "string" && titleField.value
      ? titleField.value
      : null;

  const link =
    typeof linkField?.value === "string" && linkField.value
      ? linkField.value
      : Array.isArray(linkField?.value) && linkField.value.length > 0
        ? typeof linkField.value[0] === "string"
          ? linkField.value[0]
          : linkField.value[0]?.value ?? null
        : null;

  let imageUrl = null;
  const fileData = imageField?.file?.iterator?.[0] ?? imageField?.file?.translations?.[0];
  if (fileData) {
    if (fileData.url) {
      imageUrl = fileData.url;
    } else if (fileData.dir && fileData.stored_filename) {
      let dirPath = fileData.dir.includes("/public/")
        ? "/" + fileData.dir.split("/public/")[1]
        : fileData.dir.replace("/var/www/backend/public", "");
      if (!dirPath.endsWith("/")) dirPath += "/";
      const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
      imageUrl = `${baseUrl}${dirPath}${fileData.stored_filename}`;
    }
  } else if (imageField?.file?.url) {
    imageUrl = imageField.file.url;
  } else if (typeof imageField?.file === "string") {
    imageUrl = imageField.file;
  }

  return { title, link, imageUrl };
}

export const HomeBlocks = () => {
  const { token } = useSelector((state) => state.auth);

  const { data: blocksData, refetch: refetchBlocksData } = useGetCmsSectionArticles(
    "HOMEPAGE_BLOCKS",
    { fetchArticleFields: true },
    {
      enabled: true,
    }
  );

  React.useEffect(() => {
    refetchBlocksData();
  }, [refetchBlocksData, token]);
  if (!blocksData?.items || blocksData.items.length === 0) {
    return null;
  }

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        "StylePath-Pages-Home-components-HomeBlocks"
      )}
    >
      <div className={styles.blocksContainer}>
        {blocksData.items.map((block, index) => {
          const { title, link, imageUrl } = mapHomeBlockFields(
            block.article_fields
          );

          return (
            <div key={block.id || index} className={styles.block}>
              {link ? (
                <a href={link} className={styles.blockLink}>
                  <div className={styles.imageWrapper}>
                    <img src={imageUrl} alt={title || ""} />
                  </div>
                </a>
              ) : (
                <div className={styles.imageWrapper}>
                  <img src={imageUrl} alt={title || ""} />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomeBlocks;
